<template>
  <div class="releases-by-category-modern">
    <!-- Modal: Filtrar por Período -->
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="period"
      modal-class="modern-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-calendar-alt mr-2"></i>
          Filtrar por Período
        </div>
      </template>

      <div class="modal-content-modern">
        <div class="form-grid">
          <div class="form-group">
            <label class="form-label">Data Inicial</label>
            <input v-model="start_date" type="date" class="modern-form-input" />
          </div>

          <div class="form-group">
            <label class="form-label">Data Final</label>
            <input v-model="end_date" type="date" class="modern-form-input" />
          </div>
        </div>

        <ErrorsMessages :errors="errors" />

        <div class="modal-actions">
          <v-btn class="btn-cancel-modern" @click="handleCancelFilterByPeriod">
            <i class="fas fa-times mr-2"></i>
            Cancelar
          </v-btn>
          <v-btn
            @click="handleFilterByPeriod"
            :disabled="loading"
            class="btn-filter-modern"
          >
            <i class="fas fa-filter mr-2"></i>
            {{ loading ? "Carregando..." : "Filtrar" }}
          </v-btn>
        </div>
      </div>
    </b-modal>

    <!-- Modal: Filtrar por Contas -->
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="account"
      modal-class="modern-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-university mr-2"></i>
          Filtrar por Contas
        </div>
      </template>

      <div class="modal-content-modern">
        <div class="accounts-section">
          <div class="custom-checkbox-modern">
            <input
              v-model="all_account"
              type="checkbox"
              class="checkbox-input"
              id="all-account"
              @change="handleAllAccount($event.target.checked)"
            />
            <label class="checkbox-label" for="all-account">
              <i class="fas fa-check-circle mr-1"></i>
              Todas as Contas
            </label>
          </div>

          <div class="accounts-list">
            <b-form-group>
              <b-form-checkbox
                v-for="account in finance_configuration_account"
                v-model="account_ids"
                :key="account.id"
                :value="account.id"
                @input="handleAccount"
                class="account-checkbox"
              >
                {{ account.account_nickname }}
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>

        <ErrorsMessages :errors="errors" />

        <div class="modal-actions">
          <v-btn class="btn-cancel-modern" @click="$bvModal.hide('account')">
            <i class="fas fa-times mr-2"></i>
            Cancelar
          </v-btn>
          <v-btn @click="get" :disabled="loading" class="btn-filter-modern">
            <i class="fas fa-filter mr-2"></i>
            {{ loading ? "Carregando..." : "Filtrar" }}
          </v-btn>
        </div>
      </div>
    </b-modal>

    <!-- Modal: Mais Filtros -->
    <b-modal
      size="xl"
      no-close-on-backdrop
      hide-footer
      id="filters"
      modal-class="modern-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-filter mr-2"></i>
          Mais Filtros
        </div>
      </template>

      <div class="modal-content-modern">
        <Filters
          :users="users"
          :providers="providers"
          :finance_client="finance_client"
          :finance_configuration_document_types="
            finance_configuration_document_types
          "
          :finance_configuration_payment_methods="
            finance_configuration_payment_methods
          "
          :finance_configuration_category="finance_configuration_category"
          :finance_configuration_category_parents="
            finance_configuration_category_parents
          "
          :finance_configuration_profit_cost_center="
            finance_configuration_profit_cost_center
          "
          :finance_configuration_tag="finance_configuration_tag"
          :cost_types="cost_types"
          :cost_appropriations="cost_appropriations"
          :filters="{
            types_of_entries_ids,
            users_ids,
            provider_ids,
            finance_client_ids,
            finance_configuration_document_types_ids,
            finance_configuration_payment_methods_ids,
            finance_configuration_category_ids,
            finance_configuration_profit_cost_center_ids,
            finance_configuration_tag_ids,
            cost_types_ids,
            cost_appropriations_ids,
          }"
          @success="handleSuccessFilters"
          @cancel="$bvModal.hide('filters')"
        />
      </div>
    </b-modal>

    <!-- Content Section -->
    <div class="page-container">
      <!-- Header Section -->
      <div class="page-header">
        <div class="header-content">
          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-chart-pie title-icon"></i>
              Lançamentos por Categoria
            </h1>
            <p class="page-subtitle">
              Análise de receitas e despesas por categoria
            </p>
          </div>

          <div class="actions-section">
            <v-btn
              :disabled="loading"
              @click="$bvModal.show('account')"
              class="btn-filter-action"
            >
              <i class="fas fa-university mr-2"></i>
              {{ loading ? "..." : "Contas" }}
            </v-btn>
            <v-btn
              :disabled="loading"
              @click="$bvModal.show('filters')"
              class="btn-filter-action"
            >
              <i class="fas fa-filter mr-2"></i>
              {{ loading ? "..." : "Mais Filtros" }}
            </v-btn>
            <v-btn
              v-if="hasActiveFilters"
              @click="handleCancelFilters"
              :disabled="loading"
              class="btn-clear-filter"
            >
              <i class="fas fa-times mr-2"></i>
              {{ loading ? "..." : "Limpar" }}
            </v-btn>
            <v-btn
              v-if="!loading && (pay.length > 0 || receive.length > 0)"
              class="btn-print-action"
              @click="handlePrint"
            >
              <i class="fas fa-print mr-2"></i>
              Imprimir
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Filters Bar -->
      <div class="filters-bar">
        <div class="filter-tabs">
          <v-btn
            :disabled="loading"
            class="filter-tab"
            :class="{ active: cash_competence == 'cash' }"
            @click="handleClickCashCompetence('cash')"
          >
            <i class="fas fa-money-bill-wave mr-2"></i>
            {{ loading ? "..." : "Caixa" }}
          </v-btn>
          <v-btn
            :disabled="loading"
            class="filter-tab"
            :class="{ active: cash_competence == 'competence' }"
            @click="handleClickCashCompetence('competence')"
          >
            <i class="fas fa-calendar-check mr-2"></i>
            {{ loading ? "..." : "Competência" }}
          </v-btn>
        </div>

        <div class="date-controls">
          <div class="date-navigation">
            <v-btn
              :disabled="loading"
              @click="handlePrevMonth"
              class="nav-btn prev"
            >
              <i class="fas fa-chevron-left"></i>
            </v-btn>

            <div class="date-input-container">
              <input
                v-if="dayMonthYear == 'day'"
                v-model="month"
                type="date"
                class="date-input"
                :disabled="loading"
              />
              <input
                v-if="dayMonthYear == 'month'"
                v-model="month"
                type="month"
                class="date-input"
                :disabled="loading"
                @input="get"
              />
              <input
                v-if="dayMonthYear == 'year'"
                v-model="month"
                type="text"
                class="date-input"
                maxlength="4"
                minlength="4"
                placeholder="AAAA"
                :disabled="loading"
                @input="handleInputMonthTypeYear($event.target.value)"
              />
            </div>

            <v-btn
              :disabled="loading"
              @click="handleNextMonth"
              class="nav-btn next"
            >
              <i class="fas fa-chevron-right"></i>
            </v-btn>
          </div>

          <div class="period-type-buttons">
            <v-btn
              :disabled="loading"
              @click="handleDayMonthYear('day')"
              class="period-btn"
              :class="{ active: dayMonthYear == 'day' }"
            >
              Dia
            </v-btn>
            <v-btn
              :disabled="loading"
              @click="handleDayMonthYear('month')"
              class="period-btn"
              :class="{ active: dayMonthYear == 'month' }"
            >
              Mês
            </v-btn>
            <v-btn
              :disabled="loading"
              @click="handleDayMonthYear('year')"
              class="period-btn"
              :class="{ active: dayMonthYear == 'year' }"
            >
              Ano
            </v-btn>
            <v-btn
              v-if="dayMonthYear == 'day'"
              :disabled="loading"
              class="period-btn filter-btn"
              @click="get"
            >
              <i class="fas fa-filter mr-1"></i>
              Filtrar
            </v-btn>
          </div>
        </div>

        <div class="period-filter-actions">
          <v-btn
            v-if="filter_by_period"
            @click="handleCancelFilterByPeriod"
            :disabled="loading"
            class="btn-clear-period"
          >
            <i class="fas fa-times mr-2"></i>
            {{ loading ? "..." : "Limpar Período" }}
          </v-btn>
          <v-btn
            :disabled="loading"
            @click="handleModalFilterByPeriod"
            class="btn-period-filter"
          >
            <i class="fas fa-calendar-alt mr-2"></i>
            Filtrar por Período
          </v-btn>
        </div>
      </div>

      <!-- Main Content -->
      <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
        <!-- No Results -->
        <div class="no-results" v-show="pay.length == 0 && receive.length == 0">
          <i class="fas fa-chart-pie no-results-icon"></i>
          <h3 class="no-results-title">Sem Resultados</h3>
          <p class="no-results-text">
            Nenhum lançamento encontrado para o período selecionado
          </p>
        </div>

        <!-- Charts and Results -->
        <div
          class="results-section"
          v-show="pay.length > 0 || receive.length > 0"
        >
          <!-- Charts Grid -->
          <div class="charts-grid">
            <!-- Receitas (Income) -->
            <div class="chart-card income-card">
              <div class="card-header">
                <div class="header-title">
                  <i class="fas fa-arrow-up header-icon"></i>
                  <h3 class="card-title">Receitas</h3>
                </div>
                <div class="card-badge income-badge">
                  {{ formatMoney(String(total_receive)) }}
                </div>
              </div>

              <div class="card-content">
                <div class="chart-container">
                  <GChart
                    :settings="{ packages: ['corechart'] }"
                    type="PieChart"
                    :data="dataReceive"
                    :options="chartOptionsIncome"
                  />
                </div>

                <div class="categories-list">
                  <div
                    v-for="(item, key) in receiveWithColor"
                    :key="key"
                    class="category-item"
                  >
                    <div class="category-info">
                      <div
                        class="category-color"
                        :style="`background-color: ${item.color || '#10b981'}`"
                      ></div>
                      <span class="category-name">{{ item.name }}</span>
                    </div>
                    <div class="category-values">
                      <span class="category-amount income-amount">
                        {{ formatMoney(String(item.total)) }}
                      </span>
                      <span class="category-percentage"
                        >({{ item.percentage }}%)</span
                      >
                    </div>
                  </div>

                  <div class="category-total">
                    <span class="total-label">Total</span>
                    <span class="total-value income-total">
                      {{ formatMoney(String(total_receive)) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Despesas (Expenses) -->
            <div class="chart-card expense-card">
              <div class="card-header">
                <div class="header-title">
                  <i class="fas fa-arrow-down header-icon"></i>
                  <h3 class="card-title">Despesas</h3>
                </div>
                <div class="card-badge expense-badge">
                  -{{ formatMoney(String(total_pay)) }}
                </div>
              </div>

              <div class="card-content">
                <div class="chart-container">
                  <GChart
                    :settings="{ packages: ['corechart'] }"
                    type="PieChart"
                    :data="dataPay"
                    :options="chartOptionsExpense"
                  />
                </div>

                <div class="categories-list">
                  <div
                    v-for="(item, key) in payWithColor"
                    :key="key"
                    class="category-item"
                  >
                    <div class="category-info">
                      <div
                        class="category-color"
                        :style="`background-color: ${item.color || '#ef4444'}`"
                      ></div>
                      <span class="category-name">{{ item.name }}</span>
                    </div>
                    <div class="category-values">
                      <span class="category-amount expense-amount">
                        -{{ formatMoney(String(item.total)) }}
                      </span>
                      <span class="category-percentage"
                        >({{ item.percentage }}%)</span
                      >
                    </div>
                  </div>

                  <div class="category-total">
                    <span class="total-label">Total</span>
                    <span class="total-value expense-total">
                      -{{ formatMoney(String(total_pay)) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Period Summary -->
          <div class="summary-card">
            <div class="summary-header">
              <i class="fas fa-chart-line summary-icon"></i>
              <h3 class="summary-title">Resumo do Período</h3>
            </div>

            <div class="summary-content">
              <!-- Total Receitas -->
              <div class="summary-row">
                <div class="summary-label">
                  <i class="fas fa-arrow-up mr-2"></i>
                  Total de Receitas
                </div>
                <div class="summary-progress">
                  <div class="progress-container">
                    <div
                      class="progress-bar income-progress"
                      :style="{
                        width:
                          ((total_receive / max_progress) * 100).toFixed(2) +
                          '%',
                      }"
                    ></div>
                  </div>
                </div>
                <div class="summary-value income-value">
                  {{ formatMoney(String(total_receive)) }}
                </div>
              </div>

              <!-- Total Despesas -->
              <div class="summary-row">
                <div class="summary-label">
                  <i class="fas fa-arrow-down mr-2"></i>
                  Total de Despesas
                </div>
                <div class="summary-progress">
                  <div class="progress-container">
                    <div
                      class="progress-bar expense-progress"
                      :style="{
                        width:
                          ((total_pay / max_progress) * 100).toFixed(2) + '%',
                      }"
                    ></div>
                  </div>
                </div>
                <div class="summary-value expense-value">
                  -{{ formatMoney(String(total_pay)) }}
                </div>
              </div>

              <!-- Resultado -->
              <div class="summary-row result-row">
                <div class="summary-label">
                  <i
                    :class="[
                      'fas mr-2',
                      period_result >= 0
                        ? 'fa-check-circle'
                        : 'fa-exclamation-triangle',
                    ]"
                  ></i>
                  Resultado do Período
                </div>
                <div class="summary-progress">
                  <div class="progress-container">
                    <div
                      class="progress-bar result-progress"
                      :class="{
                        'result-positive': period_result >= 0,
                        'result-negative': period_result < 0,
                      }"
                      :style="{
                        width:
                          (
                            (Math.abs(period_result) / max_progress) *
                            100
                          ).toFixed(2) + '%',
                      }"
                    ></div>
                  </div>
                </div>
                <div
                  class="summary-value result-value"
                  :class="{
                    'result-positive': period_result >= 0,
                    'result-negative': period_result < 0,
                  }"
                >
                  {{ formatMoney(String(period_result)) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
import ErrorsMessages from "../../Components/ErrorsMessages";
import Filters from "../Releases/List/Filters";
import api from "../../../services/api";
import { formatMoney, isNumeric } from "../../../lib/format";
import moment from "moment";
import { getRestHomeSelectedFinancialAccount } from "../../../lib/functions";

const INCOME_FALLBACK_COLORS = [
  "#10b981",
  "#059669",
  "#34d399",
  "#6ee7b7",
  "#a7f3d0",
  "#d1fae5",
];

const EXPENSE_FALLBACK_COLORS = [
  "#ef4444",
  "#dc2626",
  "#f87171",
  "#fca5a5",
  "#fecaca",
  "#fee2e2",
];

export default {
  name: "ReleasesByCategory",
  components: {
    GChart,
    ErrorsMessages,
    Filters,
  },
  data() {
    return {
      chartsLib: null,
      dataReceive: [["CATEGORIA", "QUANTIDADE"]],
      dataPay: [["CATEGORIA", "QUANTIDADE"]],
      pay: [],
      total_pay: 0,
      receive: [],
      total_receive: 0,
      period_result: 0,
      max_progress: 100,
      all_account: true,
      start_date: moment().format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      filter_by_period: false,
      cash_competence: "cash",
      month: moment().format("YYYY-MM"),
      month_tmp: moment().format("YYYY-MM"),
      dayMonthYear: "month",
      account_ids: [],
      types_of_entries_ids: [],
      users_ids: [],
      provider_ids: [],
      finance_client_ids: [],
      finance_configuration_document_types_ids: [],
      finance_configuration_payment_methods_ids: [],
      finance_configuration_category_ids: [],
      finance_configuration_profit_cost_center_ids: [],
      finance_configuration_tag_ids: [],
      cost_types_ids: [],
      cost_appropriations_ids: [],

      users: [],
      providers: [],
      finance_client: [],
      finance_configuration_account: [],
      finance_configuration_document_types: [],
      finance_configuration_payment_methods: [],
      finance_configuration_category: [],
      finance_configuration_category_parents: [],
      finance_configuration_profit_cost_center: [],
      finance_configuration_tag: [],
      cost_types: [
        { value: "FIXO", description: "FIXO" },
        { value: "VARIAVEL", description: "VARIÁVEL" },
      ],
      cost_appropriations: [
        { value: "DIRETO", description: "DIRETO" },
        { value: "INDIRETO", description: "INDIRETO" },
      ],
      loading: false,
      errors: [],
    };
  },
  computed: {
    hasActiveFilters() {
      return (
        this.types_of_entries_ids.length > 0 ||
        this.users_ids.length > 0 ||
        this.provider_ids.length > 0 ||
        this.finance_client_ids.length > 0 ||
        this.finance_configuration_document_types_ids.length > 0 ||
        this.finance_configuration_payment_methods_ids.length > 0 ||
        this.finance_configuration_category_ids.length > 0 ||
        this.finance_configuration_profit_cost_center_ids.length > 0 ||
        this.finance_configuration_tag_ids.length > 0 ||
        this.cost_types_ids.length > 0 ||
        this.cost_appropriations_ids.length > 0
      );
    },
    receiveWithColor() {
      return this.receive.map((item, index) => ({
        ...item,
        color:
          item.color ||
          INCOME_FALLBACK_COLORS[index % INCOME_FALLBACK_COLORS.length],
      }));
    },
    payWithColor() {
      return this.pay.map((item, index) => ({
        ...item,
        color:
          item.color ||
          EXPENSE_FALLBACK_COLORS[index % EXPENSE_FALLBACK_COLORS.length],
      }));
    },
    chartOptionsIncome() {
      return {
        pieHole: 0.4,
        height: 350,
        backgroundColor: "transparent",
        colors: this.receiveWithColor.map((item) => item.color),
        legend: {
          position: "none",
        },
        chartArea: {
          left: 20,
          top: 20,
          width: "90%",
          height: "85%",
        },
        pieSliceTextStyle: {
          color: "white",
          fontSize: 12,
          fontName: "WorkSans-SemiBold",
        },
      };
    },
    chartOptionsExpense() {
      return {
        pieHole: 0.4,
        height: 350,
        backgroundColor: "transparent",
        colors: this.payWithColor.map((item) => item.color),
        legend: {
          position: "none",
        },
        chartArea: {
          left: 20,
          top: 20,
          width: "90%",
          height: "85%",
        },
        pieSliceTextStyle: {
          color: "white",
          fontSize: 12,
          fontName: "WorkSans-SemiBold",
        },
      };
    },
  },
  async created() {
    await this.financeConfigurationAccount();
    await this.get();
    await this.getUsers();
    await this.provider();
    await this.financeClient();
    await this.financeConfigurationPaymentMethods();
    await this.financeConfigurationDocumentTypes();
    await this.financeConfigurationCategory();
    await this.financeConfigurationProfitCostCenter();
    await this.financeConfigurationTag();
  },
  methods: {
    getRestHomeSelectedFinancialAccount,
    formatMoney,
    handleSuccessFilters(data) {
      let {
        types_of_entries_ids,
        users_ids,
        provider_ids,
        finance_client_ids,
        finance_configuration_document_types_ids,
        finance_configuration_payment_methods_ids,
        finance_configuration_category_ids,
        finance_configuration_profit_cost_center_ids,
        finance_configuration_tag_ids,
        cost_types_ids,
        cost_appropriations_ids,
      } = data;

      this.types_of_entries_ids = types_of_entries_ids;
      this.users_ids = users_ids;
      this.provider_ids = provider_ids;
      this.finance_client_ids = finance_client_ids;
      this.finance_configuration_document_types_ids =
        finance_configuration_document_types_ids;
      this.finance_configuration_payment_methods_ids =
        finance_configuration_payment_methods_ids;
      this.finance_configuration_category_ids =
        finance_configuration_category_ids;
      this.finance_configuration_profit_cost_center_ids =
        finance_configuration_profit_cost_center_ids;
      this.finance_configuration_tag_ids = finance_configuration_tag_ids;
      this.cost_types_ids = cost_types_ids;
      this.cost_appropriations_ids = cost_appropriations_ids;

      this.$bvModal.hide("filters");
      this.get();
    },
    handleAllAccount(all) {
      let { finance_configuration_account } = this;

      if (all) {
        for (let item of finance_configuration_account) {
          this.account_ids.push(item.id);
        }
        this.all_account = true;
      } else {
        this.account_ids = [];
        this.all_account = false;
      }
    },
    handleAccount() {
      let { account_ids, finance_configuration_account } = this;

      if (finance_configuration_account.length > account_ids.length) {
        this.all_account = false;
      } else {
        this.all_account = true;
      }
    },
    handleCancelFilters() {
      this.types_of_entries_ids = [];
      this.users_ids = [];
      this.provider_ids = [];
      this.finance_client_ids = [];
      this.finance_configuration_document_types_ids = [];
      this.finance_configuration_payment_methods_ids = [];
      this.finance_configuration_category_ids = [];
      this.finance_configuration_profit_cost_center_ids = [];
      this.finance_configuration_tag_ids = [];
      this.cost_types_ids = [];
      this.cost_appropriations_ids = [];

      this.$bvModal.hide("filters");
      this.get();
    },
    handleClickCashCompetence(cash_competence) {
      if (this.cash_competence != cash_competence) {
        this.cash_competence = cash_competence;
        this.get();
      }
    },
    handlePrint() {
      let {
        cash_competence,
        month,
        dayMonthYear,
        account_ids,
        types_of_entries_ids,
        users_ids,
        provider_ids,
        finance_client_ids,
        finance_configuration_document_types_ids,
        finance_configuration_payment_methods_ids,
        finance_configuration_category_ids,
        finance_configuration_profit_cost_center_ids,
        finance_configuration_tag_ids,
        cost_types_ids,
        cost_appropriations_ids,
        filter_by_period,
        start_date,
        end_date,
      } = this;

      let route = this.$router.resolve({
        name: "print-releases-by-category",
        params: {
          cash_competence,
          month,
          dayMonthYear,
          account_ids: account_ids.join(","),
          types_of_entries_ids:
            types_of_entries_ids.length > 0
              ? types_of_entries_ids.join(",")
              : false,
          users_ids: users_ids.length > 0 ? users_ids.join(",") : false,
          provider_ids:
            provider_ids.length > 0 ? provider_ids.join(",") : false,
          finance_client_ids:
            finance_client_ids.length > 0
              ? finance_client_ids.join(",")
              : false,
          finance_configuration_document_types_ids:
            finance_configuration_document_types_ids.length > 0
              ? finance_configuration_document_types_ids.join(",")
              : false,
          finance_configuration_payment_methods_ids:
            finance_configuration_payment_methods_ids.length > 0
              ? finance_configuration_payment_methods_ids.join(",")
              : false,
          finance_configuration_category_ids:
            finance_configuration_category_ids.length > 0
              ? finance_configuration_category_ids.join(",")
              : false,
          finance_configuration_profit_cost_center_ids:
            finance_configuration_profit_cost_center_ids.length > 0
              ? finance_configuration_profit_cost_center_ids.join(",")
              : false,
          finance_configuration_tag_ids:
            finance_configuration_tag_ids.length > 0
              ? finance_configuration_tag_ids.join(",")
              : false,
          cost_types_ids:
            cost_types_ids.length > 0 ? cost_types_ids.join(",") : false,
          cost_appropriations_ids:
            cost_appropriations_ids.length > 0
              ? cost_appropriations_ids.join(",")
              : false,
          filter_by_period,
          start_date,
          end_date,
        },
      });

      window.open(route.href, "_blank");
    },
    handlePrevMonth() {
      let { dayMonthYear } = this;

      if (dayMonthYear == "day") {
        this.month = moment(this.month)
          .subtract(1, "days")
          .format("YYYY-MM-DD");
      } else if (dayMonthYear == "month") {
        this.month = moment(this.month).subtract(1, "month").format("YYYY-MM");
      } else {
        this.month = moment(this.month).subtract(1, "year").format("YYYY");
      }
      this.get();
    },
    handleNextMonth() {
      let { dayMonthYear } = this;

      if (dayMonthYear == "day") {
        this.month = moment(this.month).add(1, "days").format("YYYY-MM-DD");
      } else if (dayMonthYear == "month") {
        this.month = moment(this.month).add(1, "month").format("YYYY-MM");
      } else {
        this.month = moment(this.month).add(1, "year").format("YYYY");
      }

      this.get();
    },
    handleDayMonthYear(dayMonthYear) {
      if (dayMonthYear == this.dayMonthYear) {
        return;
      }

      let { month, month_tmp } = this;

      this.month = moment().format("YYYY-MM-DD");

      if (dayMonthYear == "month") {
        this.month = moment(month_tmp).format("YYYY-MM");
        this.month_tmp = moment(month_tmp).format("YYYY-MM");
      }

      if (dayMonthYear == "year") {
        this.month = moment(month).format("YYYY");
        this.month_tmp = moment(month_tmp).format("YYYY-MM-DD");
      }

      this.dayMonthYear = dayMonthYear;
      this.get();
    },
    handleInputMonthTypeYear(year) {
      if (String(year).length == 4) {
        if (isNumeric(year)) {
          this.get();
        }
      }
    },
    handleModalFilterByPeriod() {
      this.$bvModal.show("period");
    },
    handleCancelFilterByPeriod() {
      this.$bvModal.hide("period");
      this.start_date = moment().format("YYYY-MM-DD");
      this.end_date = moment().format("YYYY-MM-DD");
      this.filter_by_period = false;
      this.get();
    },
    handleFilterByPeriod() {
      let { start_date, end_date } = this;

      if (!start_date) {
        this.errors = ["Informe a data inicial"];
        return;
      }

      if (!end_date) {
        this.errors = ["Informe a data final"];
        return;
      }

      if (
        parseInt(moment(start_date).format("YYYYMMDD")) >
        parseInt(moment(end_date).format("YYYYMMDD"))
      ) {
        this.errors = ["Informe a data final igual ou maior a data inicial"];
        return;
      }

      this.filter_by_period = true;
      this.get();
    },
    async getUsers() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get("/rest-home/users-actives", {
          params,
        });

        const { users } = response.data;

        this.users = users;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationAccount() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/account-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        if (this.account_ids.length == 0) {
          for (let item of data) {
            this.account_ids.push(item.id);
          }
        }

        this.finance_configuration_account = data;
      } catch (error) {
        console.log(error);
      }
    },
    async provider() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        const params = { rest_home_id_selected_financial_account, active: 1 };

        const response = await api.get("/rest-home/providers", {
          params,
        });

        const { providers } = response.data;

        this.providers = providers;
      } catch (error) {
        console.log(error);
      }
    },
    async financeClient() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get("/rest-home/financial/client-actives", {
          params,
        });

        const { data } = response.data;

        this.finance_client = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationPaymentMethods() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/payment-methods-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_payment_methods = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationDocumentTypes() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/document-types-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_document_types = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationCategory() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/category-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        let parents = [];
        let daughters = [];
        for (let item of data) {
          if (item.type == "parent") {
            parents.push(item);
          } else {
            daughters.push(item);
          }
        }

        for (let parent of parents) {
          parent.items = [];
          for (let daughter of daughters) {
            if (daughter.finance_configuration_category_id == parent.id) {
              parent.items.push(daughter);
            }
          }
        }

        this.finance_configuration_category_parents = parents;
        this.finance_configuration_category = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationProfitCostCenter() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/profit-cost-center-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_profit_cost_center = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationTag() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/tags-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_tag = data;
      } catch (error) {
        console.log(error);
      }
    },
    async get() {
      try {
        this.loading = true;

        this.dataReceive = [["CATEGORIA", "QUANTIDADE"]];
        this.dataPay = [["CATEGORIA", "QUANTIDADE"]];

        let {
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
        } = this;

        let params = {
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
        };

        const response = await api.get(
          "/rest-home/financial/reports/releases-by-category",
          { params }
        );

        const { error, errors, pay, total_pay, receive, total_receive } =
          response.data;

        if (error) {
          this.errors = errors;
          this.receive = [];
          this.total_receive = 0;
          this.pay = [];
          this.total_pay = 0;
          this.max_progress = 0;
          this.period_result = 0;
        } else {
          this.errors = [];
          let pays = [];
          let receives = [];

          for (let item of receive) {
            if (item.total > 0) {
              let total = item.total;
              let init = String(total).substr(0, String(total).length - 2);
              let end = String(total).substr(String(total).length - 2, 2);
              this.dataReceive.push([item.name, parseFloat(`${init}.${end}`)]);
              let percentage = (item.total * 100) / total_receive;
              percentage = percentage.toFixed(2);
              receives.push({ ...item, percentage });
            }
          }

          for (let item of pay) {
            if (item.total > 0) {
              let total = item.total;
              let init = String(total).substr(0, String(total).length - 2);
              let end = String(total).substr(String(total).length - 2, 2);
              this.dataPay.push([item.name, parseFloat(`${init}.${end}`)]);
              let percentage = (item.total * 100) / total_pay;
              percentage = percentage.toFixed(2);
              pays.push({ ...item, percentage });
            }
          }

          this.receive = receives;
          this.total_receive = total_receive;
          this.pay = pays;
          this.total_pay = total_pay;

          if (parseFloat(total_pay) >= parseFloat(total_receive)) {
            this.max_progress = total_pay;
          } else {
            this.max_progress = total_receive;
          }

          this.period_result =
            parseFloat(total_receive) - parseFloat(total_pay);

          this.$bvModal.hide("account");
          this.$bvModal.hide("period");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.releases-by-category-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.page-container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 24px 32px 24px;
}

/* Header Section */
.page-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
}

.header-content {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.title-section {
  flex: 1;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

.actions-section {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-filter-action {
  background: linear-gradient(135deg, #1f5a76 0%, #0f4c75 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(31, 90, 118, 0.3) !important;
  transition: all 0.3s ease !important;
  font-size: 13px !important;
}

.btn-filter-action:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(31, 90, 118, 0.4) !important;
}

.btn-clear-filter {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3) !important;
  transition: all 0.3s ease !important;
  font-size: 13px !important;
}

.btn-clear-filter:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4) !important;
}

.btn-print-action {
  background: linear-gradient(135deg, #33495e 0%, #1e293b 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(51, 73, 94, 0.3) !important;
  transition: all 0.3s ease !important;
  font-size: 13px !important;
}

.btn-print-action:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(51, 73, 94, 0.4) !important;
}

/* Filters Bar */
.filters-bar {
  background: white;
  border-radius: 16px;
  padding: 20px 24px;
  margin-bottom: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.filter-tabs {
  display: flex;
  gap: 8px;
}

.filter-tab {
  background: #f8fafc !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
  box-shadow: none !important;
}

.filter-tab:hover {
  background: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
}

.filter-tab.active {
  background: linear-gradient(135deg, #1f5a76 0%, #0f4c75 100%) !important;
  color: white !important;
  border-color: #1f5a76 !important;
  box-shadow: 0 4px 15px rgba(31, 90, 118, 0.3) !important;
}

.date-controls {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.date-navigation {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nav-btn {
  background: #f8fafc !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 10px !important;
  padding: 8px !important;
  min-width: 40px !important;
  width: 40px !important;
  height: 40px !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

.nav-btn:hover {
  background: #0f65b0 !important;
  color: white !important;
  border-color: #0f65b0 !important;
}

.date-input-container {
  min-width: 180px;
}

.date-input {
  width: 100%;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  transition: all 0.3s ease;
  font-family: "WorkSans-Regular", sans-serif;
}

.date-input:focus {
  border-color: #0f65b0;
  outline: none;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
}

.period-type-buttons {
  display: flex;
  gap: 8px;
}

.period-btn {
  background: #f8fafc !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 10px !important;
  padding: 10px 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
  box-shadow: none !important;
  font-size: 13px !important;
}

.period-btn:hover {
  background: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
}

.period-btn.active {
  background: linear-gradient(135deg, #1f5a76 0%, #0f4c75 100%) !important;
  color: white !important;
  border-color: #1f5a76 !important;
  box-shadow: 0 2px 8px rgba(31, 90, 118, 0.3) !important;
}

.period-btn.filter-btn {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border-color: #0f65b0 !important;
  box-shadow: 0 2px 8px rgba(15, 101, 176, 0.3) !important;
}

.period-filter-actions {
  display: flex;
  gap: 12px;
}

.btn-clear-period {
  background: transparent !important;
  color: #ef4444 !important;
  border: 2px solid #ef4444 !important;
  border-radius: 10px !important;
  padding: 10px 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
  box-shadow: none !important;
  font-size: 13px !important;
}

.btn-clear-period:hover {
  background: #ef4444 !important;
  color: white !important;
}

.btn-period-filter {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 10px 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 2px 8px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
  font-size: 13px !important;
}

.btn-period-filter:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(15, 101, 176, 0.4) !important;
}

/* Loading Overlay */
.loading-overlay {
  border-radius: 16px;
  min-height: 400px;
}

/* No Results */
.no-results {
  text-align: center;
  padding: 80px 24px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.no-results-icon {
  font-size: 64px;
  color: #cbd5e1;
  margin-bottom: 20px;
}

.no-results-title {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.no-results-text {
  font-size: 16px;
  color: #64748b;
  margin: 0;
}

/* Results Section */
.results-section {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* Charts Grid */
.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 32px;
}

.chart-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  transition: all 0.3s ease;
}

.chart-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.income-card .card-header {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border-bottom: 2px solid #34d399;
}

.expense-card .card-header {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border-bottom: 2px solid #f87171;
}

.card-header {
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-icon {
  font-size: 20px;
}

.income-card .header-icon {
  color: #059669;
}

.expense-card .header-icon {
  color: #dc2626;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.income-card .card-title {
  color: #065f46;
}

.expense-card .card-title {
  color: #991b1b;
}

.card-badge {
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 700;
}

.income-badge {
  background: rgba(16, 185, 129, 0.2);
  color: #065f46;
}

.expense-badge {
  background: rgba(239, 68, 68, 0.2);
  color: #991b1b;
}

.card-content {
  padding: 24px;
}

.chart-container {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}

/* Categories List */
.categories-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.category-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.category-item:hover {
  background: #f1f5f9;
  transform: translateX(4px);
}

.category-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.category-color {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.category-name {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.category-values {
  display: flex;
  align-items: center;
  gap: 8px;
}

.category-amount {
  font-size: 15px;
  font-weight: 600;
}

.income-amount {
  color: #10b981;
}

.expense-amount {
  color: #ef4444;
}

.category-percentage {
  font-size: 12px;
  color: #6b7280;
}

.category-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: white;
  border-radius: 8px;
  border: 2px solid #e5e7eb;
  margin-top: 8px;
}

.total-label {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.total-value {
  font-size: 18px;
  font-weight: 700;
}

.income-total {
  color: #10b981;
}

.expense-total {
  color: #ef4444;
}

/* Summary Card */
.summary-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.summary-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 20px 24px;
  border-bottom: 2px solid #cbd5e1;
  display: flex;
  align-items: center;
  gap: 12px;
}

.summary-icon {
  color: #0f65b0;
  font-size: 20px;
}

.summary-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.summary-content {
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.summary-row {
  display: grid;
  grid-template-columns: 200px 1fr 150px;
  align-items: center;
  gap: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.summary-row:hover {
  background: #f1f5f9;
  transform: translateX(4px);
}

.result-row {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border: 2px solid #cbd5e1;
}

.summary-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
}

.summary-progress {
  flex: 1;
}

.progress-container {
  width: 100%;
  height: 12px;
  background: #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  transition: width 0.8s ease;
  border-radius: 6px;
}

.income-progress {
  background: linear-gradient(90deg, #10b981 0%, #059669 100%);
}

.expense-progress {
  background: linear-gradient(90deg, #ef4444 0%, #dc2626 100%);
}

.result-progress.result-positive {
  background: linear-gradient(90deg, #10b981 0%, #059669 100%);
}

.result-progress.result-negative {
  background: linear-gradient(90deg, #ef4444 0%, #dc2626 100%);
}

.summary-value {
  font-size: 16px;
  font-weight: 700;
  text-align: right;
}

.income-value {
  color: #10b981;
}

.expense-value {
  color: #ef4444;
}

.result-value.result-positive {
  color: #10b981;
}

.result-value.result-negative {
  color: #ef4444;
}

/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-content-modern {
  padding: 8px 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.modern-form-input {
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  transition: all 0.3s ease;
  font-family: "WorkSans-Regular", sans-serif;
}

.modern-form-input:focus {
  border-color: #0f65b0;
  outline: none;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
}

.btn-cancel-modern {
  background: transparent !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 10px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
  box-shadow: none !important;
}

.btn-cancel-modern:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
}

.btn-filter-modern {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-filter-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4) !important;
}

.btn-filter-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Accounts Section */
.accounts-section {
  margin-bottom: 24px;
}

.custom-checkbox-modern {
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.checkbox-input {
  width: 18px;
  height: 18px;
  margin-right: 12px;
  cursor: pointer;
}

.checkbox-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.accounts-list {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  max-height: 300px;
  overflow-y: auto;
}

.account-checkbox {
  margin-bottom: 8px;
  font-weight: 500;
  color: #374151;
}

/* Scrollbar personalizada */
.accounts-list::-webkit-scrollbar {
  width: 6px;
}

.accounts-list::-webkit-scrollbar-track {
  background: #e5e7eb;
  border-radius: 3px;
}

.accounts-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.accounts-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .charts-grid {
    grid-template-columns: 1fr;
  }

  .summary-row {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .summary-value {
    text-align: left;
  }
}

@media (max-width: 768px) {
  .page-container {
    padding: 0 16px 24px 16px;
  }

  .page-header {
    padding: 20px 0;
    margin-bottom: 20px;
  }

  .header-content {
    flex-direction: column;
    align-items: stretch;
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .actions-section {
    flex-direction: column;
  }

  .filters-bar {
    padding: 16px;
  }

  .date-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .date-navigation {
    width: 100%;
  }

  .date-input-container {
    flex: 1;
  }

  .period-type-buttons {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }

  .period-filter-actions {
    flex-direction: column;
  }

  .summary-row {
    padding: 12px;
  }

  .summary-label {
    font-size: 13px;
  }

  .summary-value {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .chart-card {
    border-radius: 12px;
  }

  .card-content {
    padding: 16px;
  }

  .categories-list {
    gap: 8px;
  }

  .category-item {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .category-values {
    justify-content: space-between;
  }

  .period-type-buttons {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Override Bootstrap Vue Modal */
.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-bottom: 1px solid #e5e7eb;
  border-radius: 0;
}

.modern-modal >>> .modal-body {
  padding: 24px;
}

.modern-modal >>> .modal-content {
  border-radius: 16px;
  border: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

/* Custom Checkbox Styling */
.account-checkbox
  >>> .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: #0f65b0;
  border-color: #0f65b0;
}

.account-checkbox >>> .custom-control-label {
  font-family: "WorkSans-Regular", sans-serif;
  color: #374151;
}
</style>